export const RAILS_ROUTES = {
  ABOUT: '/about',
  ACTUATORS: '/actuators',
  ADMIN: '/admin',
  ADMIN_CHECKOUT: '/admin/checkout',
  APPLICATIONS: '/applications',
  BLOGS: '/blogs',
  CAREERS: '/careers',
  CHECKOUT_CART: '/checkout/cart',
  CNC_MACHINE_TENDING: '/cnc-machine-tending',
  CONTACT: '/contact',
  CONVEYORS: '/conveyors',
  CUSTOMER_STORIES: '/customer-stories',
  INDUSTRIAL_CARTS: '/industrial-carts',
  INDUSTRIAL_PALLETIZER: '/industrial-palletizer',
  DASHBOARD: '/dashboard',
  DASHBOARD_CATALOG: '/dashboard/catalog',
  DASHBOARD_DESIGNS: '/dashboard/designs',
  DASHBOARD_MACHINE_ANALYTICS: '/dashboard/machine_analytics',
  DASHBOARD_NEW_DESIGN: '/dashboard/new-design',
  DASHBOARD_ORDERS: '/dashboard/orders',
  DASHBOARD_PROJECTS: '/dashboard/projects',
  DASHBOARD_SETTINGS_USER: '/dashboard/settings/user',
  DESIGN_TEMPLATES_ASSEMBLY: '/designs/official?category=AS#f-ec_category=AS',
  DESIGN_TEMPLATES_EOL_PACKAGING: '/designs/official?category=PZ#f-ec_category=PZ',
  DESIGN_TEMPLATES_MANUFACTURING: '/designs/official?category=MF#f-ec_category=MF',
  DESIGN_TEMPLATES_MATERIAL_HANDLING: '/designs/official?category=MH#f-ec_category=MH',
  DESIGNS_OFFICIAL: '/designs/official',
  EVENTS: '/events',
  EXPERIENCE_CENTER: '/experience-center',
  HARDWARE: '/hardware',
  HOME: '/?home',
  MACHINE_ANALYTICS: '/machine-analytics',
  MACHINE_BUILDER: '/machine-builder',
  MACHINE_LOGIC: '/machine-logic',
  MACHINEMOTION_AI: '/machinemotion-ai',
  MANUFACTURING_AUTOMATION_PLATFORM: '/manufacturing-automation-platform',
  PARTS_LIBRARY: '/parts-library',
  PATH_FOLLOWING: '/path-following',
  PICK_AND_PLACE: '/pick-and-place',
  PRESS: '/press',
  ROBOTIC_SANDING: '/robotic-sanding',
  ROBOTIC_WELDING: '/robotic-welding',
  RESOURCES_FAQS: '/resources/faqs',
  RESOURCES_VIDEO_TUTORIALS: '/resources/video-tutorials',
  SERVICES_REMOTE_SUPPORT: '/services/remote-support',
  SIGNUP_GENERIC: '/signup',
  SUBSCRIPTIONS: '/subscriptions',
  TOOLS: '/tools',
  USERS_SIGN_IN: '/users/sign_in',
  VENTION_AUTOMATION_PARTNER: '/vention-automation-partner',
  WEBINARS: '/webinars',
};

export const MARKETING_ROUTES = {
  COBOT_PALLETIZER: '/cobot-palletizer',
  DEMO_DAY: '/demo-day',
  END_OF_LINE_SOLUTIONS: '/end-of-line-solutions',
  PHYSICAL_AI_PIPELINE: '/physical-ai-pipeline',
  RAPID_OPERATOR_AI: '/rapid-operator-ai',
  ROBOT_ARM: '/robot-arm',
  SERVICES_DEPLOYMENT_SERVICES: '/services/deployment-services',
  SERVICES_DESIGN_SERVICES: '/services/design-services',
  SERVICES_REMOTE_SUPPORT: '/services/post-sale-support',
  SERVICES_TRAINING_SESSIONS: '/services/training-sessions',
};

export const EXTERNAL_ROUTES = {
  BOOK_MEETING: 'https://vention.io/free-video-call',
  DOC360_TECH_DOC_KNOWLEDGE_BASE: 'https://docs.vention.io',
  DOCS_API: 'https://docs.vention.io/docs/application-programming-interface-python',
  DOCS_RELEASE_NOTES: 'https://docs.vention.io/release-notes',
  HOW_TO_GUIDES: 'https://docs.vention.io/docs/search?searchtext=how%20to&selectedTab=2',
};
